"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EWItem = void 0;
var __1 = require("..");
var EWItem = /** @class */ (function () {
    function EWItem(folderName, baseItem) {
        if (!folderName || !baseItem) {
            throw new Error('Both folderName and baseItem has to be defined!');
        }
        this.folderName = folderName;
        this.baseItem = baseItem;
    }
    EWItem.prototype.getEmailAddress = function () {
        switch (this.folderName) {
            case __1.FolderNames.contacts:
                {
                    var contact = this.baseItem;
                    return contact.Email1Address || contact.Email2Address || contact.Email3Address;
                }
            case __1.FolderNames.leads:
                {
                    var lead = this.baseItem;
                    return lead.Email;
                }
            case __1.FolderNames.companies:
                {
                    var company = this.baseItem;
                    return company.Email;
                }
            case __1.FolderNames.users:
                {
                    var user = this.baseItem;
                    return user.Email1Address || user.Email2Address;
                }
            default:
                return null;
        }
    };
    EWItem.prototype.getInitials = function () {
        switch (this.folderName) {
            case __1.FolderNames.contacts:
                {
                    var contact = this.baseItem;
                    return this.getInitialsInternal(contact.FirstName, contact.LastName);
                }
            case __1.FolderNames.users:
                {
                    var user = this.baseItem;
                    return this.getInitialsInternal(user.FirstName, user.LastName);
                }
            default:
                return null;
        }
    };
    EWItem.prototype.getInitialsInternal = function (firstName, lastName) {
        var initials = ((firstName === null || firstName === void 0 ? void 0 : firstName.substr(0, 1)) || '') + ((lastName === null || lastName === void 0 ? void 0 : lastName.substr(0, 1)) || '');
        if (initials == '')
            return null;
        return initials;
    };
    EWItem.prototype.getItemPreview = function () {
        switch (this.folderName) {
            case __1.FolderNames.contacts:
                {
                    var contact = this.baseItem;
                    if (!contact.ProfilePicture)
                        return null;
                    return {
                        imageData: contact.ProfilePicture,
                        width: contact.ProfilePictureWidth || 0,
                        height: contact.ProfilePictureHeight || 0
                    };
                }
            case __1.FolderNames.users:
                {
                    var user = this.baseItem;
                    if (!user.ProfilePicture)
                        return null;
                    return {
                        imageData: user.ProfilePicture,
                        width: user.ProfilePictureWidth || 0,
                        height: user.ProfilePictureHeight || 0
                    };
                }
            default:
                return null;
        }
    };
    return EWItem;
}());
exports.EWItem = EWItem;
